module.exports = __webpack_public_path__ + "img/weixin3.ece1ecc3.png";